/* ============================================================
   SHOCK'D Homepage — behavior layer
   Homepage-only flourishes. Shared behaviors (header menu/search,
   recent-purchase toast, scroll reveal, countdown/header height sync)
   are handled by shockd-pdp.js, which also runs on this template.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    if (!document.body.matches('[data-shockd-home="1"]')) return;

    bindCountUps();
    bindBackgroundVideos();
  });

  /* ---------- Animated stat count-ups ----------
     Any element with [data-sd-countup="42"] counts from 0 to its target
     when it scrolls into view. Optional [data-sd-suffix] / [data-sd-prefix]
     and [data-sd-decimals] for things like "130", "100%", "4.9". */
  function bindCountUps() {
    var els = [].slice.call(document.querySelectorAll('[data-sd-countup]'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = formatStat(el, target(el)); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animate(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) { io.observe(el); });
  }

  function target(el) {
    return parseFloat(el.getAttribute('data-sd-countup')) || 0;
  }

  function formatStat(el, value) {
    var decimals = parseInt(el.getAttribute('data-sd-decimals'), 10) || 0;
    var prefix = el.getAttribute('data-sd-prefix') || '';
    var suffix = el.getAttribute('data-sd-suffix') || '';
    var n = decimals ? value.toFixed(decimals) : Math.round(value).toLocaleString();
    return prefix + n + suffix;
  }

  function animate(el) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = formatStat(el, target(el));
      return;
    }
    var end = target(el);
    var dur = 1400;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      // easeOutExpo
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      el.textContent = formatStat(el, end * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- Background videos ----------
     Forces reliable muted autoplay (some browsers block it unless the
     attributes are set in JS too) and pauses videos while off-screen to
     save battery/CPU. Targets <video data-sd-bgvideo>. */
  function bindBackgroundVideos() {
    var vids = [].slice.call(document.querySelectorAll('video[data-sd-bgvideo]'));
    if (!vids.length) return;

    vids.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      var tryPlay = function () {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      };
      if (v.readyState >= 2) tryPlay();
      else v.addEventListener('loadeddata', tryPlay, { once: true });
    });

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.05 });
    vids.forEach(function (v) { io.observe(v); });
  }
})();
